import makeKey from "core/cache/KeyGen.js";
import { getEnabledElement } from "component/toolManager/enabledElements.js";
import triggerEvent from "core/customEvent/triggerEvent.js";
import math from "core/math";
import Cache from "core/cache/index";
import Helper from "helper";
import Config from "config";
/**
 * 자동 Frame 일치
 * Synchronize the target stack to the image closest to the source image's position
 * @export
 * @public
 * @method
 * @name stackImagePositionSynchronizer
 *
 * @param {Object} synchronizer - The Synchronizer instance that attaches this
 * handler to an event
 * @param {HTMLElement} sourceElement - The source element for the image position
 * @param {HTMLElement} targetElement - The target element
 * @returns {void}
 */
//export default function(synchronizer, sourceElement, targetElement) {
export default function (
  synchronizer,
  sourceElement,
  targetElement,
  newImageIndex
) {
  // Ignore the case where the source and target are the same enabled element
  if (targetElement === sourceElement) {
    return;
  }
  if (Config.rootStore.toolbarStore.isBatchViewMode() === true) {
    return;
  }

  let metadataCache = new Cache.Metadata();
  const sourceElementStub = getEnabledElement(sourceElement);

  if (sourceElementStub.image === undefined) {
    let a = "fdsdf";
  }

  const sourceSeriesKey = makeKey(
    sourceElementStub.image.seriesInstanceUID,
    sourceElementStub.image.modality
  );

  const sourceImage = metadataCache.get(sourceSeriesKey).stack[0].frame[
    newImageIndex
  ];
  if (!!sourceImage === false) {
    return;
  }

  let sourceImagePlane = metadataCache.getImagePlaneModule(sourceSeriesKey);
  sourceImagePlane.imagePositionPatient = sourceImage.imagePosition;
  sourceImagePlane.frameOfReferenceUID = sourceImage.frameOfReferenceUID;
  if (Helper.Validator.validateImagePlaneModule(sourceImagePlane) === false) {
    // Console.log('No position found for image ' + sourceImage.imageId);

    return;
  }
  const sourceImagePosition = math.vector.convertToVector3(
    sourceImagePlane.imagePositionPatient
  );

  const targetElementStub = getEnabledElement(targetElement);
  const targetSeriesKey = makeKey(
    targetElementStub.image.seriesInstanceUID,
    targetElementStub.image.modality
  );
  const stackData = metadataCache.get(targetSeriesKey).stack[0].frame;

  let minDistance = Number.MAX_VALUE;
  let newImageIdIndex = -1;

  stackData.forEach((frame, index) => {
    if (frame.imagePosition === undefined) {
      return;
    }
    const imagePosition = math.vector.convertToVector3(frame.imagePosition);
    const distance = imagePosition.distanceToSquared(sourceImagePosition);

    if (distance < minDistance) {
      minDistance = distance;
      newImageIdIndex = index;
    }
  });

  if (newImageIdIndex === stackData.currentImageIdIndex) {
    return;
  }

  const data = {
    newImageIndex: newImageIdIndex,
  };
  triggerEvent(targetElement, "onChangeScrollbar", data);
}
